<feature-banner
    [notification]="populatedNotification"
    (dismissNotification)="dismissNotification.emit(populatedNotification)"
>
</feature-banner>

<ng-template #enhancedSafemodeButtonTemplate>
    <!-- NO BTN IS NEEDED -->
</ng-template>
